"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _storage = require("@/api/storage");
var _auth = require("@/utils/auth");
var _faq = require("@/api/faq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function extractUniqueObjectsByProp(arr1, arr2, prop) {
  // 使用Set存储第二个数组中对象的prop值，便于快速查找。
  var set2 = new Set(arr2.map(function (obj) {
    return obj[prop];
  }));
  // 过滤第一个数组中不在set2中的对象。
  return arr1.filter(function (obj1) {
    return !set2.has(obj1[prop]);
  });
}
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    MultiLanguageInp: _MultiLanguageInp.default,
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      uploadPath: _storage.uploadPath,
      tabsAll: [],
      tabsOne: [],
      activeNameOne: '',
      tabsTwo: [],
      activeNameTwo: '',
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        sort: 'add_time',
        order: 'desc'
      },
      total: 0,
      list: [],
      LanguageList: [],
      dialogStatus: '',
      dialogFormVisible: false,
      dialogTitle: '',
      required: {
        required: true,
        message: '类目名称不能为空',
        trigger: 'blur'
      },
      requiredName: {
        required: true,
        message: '标题不能为空',
        trigger: 'blur'
      },
      dataForm: {
        id: undefined,
        name: '',
        sort: '',
        image: ''
      },
      ruleFormVisible: false,
      ruleForm: {
        id: undefined,
        name: '',
        status: 1
      },
      initRuleForm: {},
      oldTabsOne: [],
      oldTabsTwo: [],
      activeName: '',
      form: {},
      type: ''
    };
  },
  computed: {
    rules: function rules() {
      return {
        name: [this.required]
      };
    },
    DetailRules: function DetailRules() {
      return {
        name: [this.requiredName]
      };
    },
    headers: function headers() {
      return {
        'Mu-Token': (0, _auth.getToken)()
      };
    }
  },
  mounted: function mounted() {
    this.getLanguageList();
    this.getList();
  },
  methods: {
    onSort: function onSort(e, row) {
      this.onEnable(null, row);
      //  this.handleUpdate(row)
    },
    getLanguageList: function getLanguageList() {
      var _this = this;
      (0, _faq.languageList)().then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this.LanguageList = dataRes.data;
          if (_this.LanguageList.length > 0) {
            _this.activeName = _this.LanguageList[0].label;
          }
          var fileUrl = {};
          _this.LanguageList.forEach(function (ele) {
            fileUrl[ele.label] = '';
          });
          _this.form = (0, _objectSpread2.default)({}, fileUrl);
          var form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.ruleForm), fileUrl);
          _this.ruleForm = (0, _objectSpread2.default)({}, form);
          _this.initRuleForm = (0, _objectSpread2.default)({}, form);
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this2 = this;
      this.ruleForm = Object.assign({}, row);
      this.$set(this.ruleForm, 'id', row.id);
      console.log(this.ruleForm, row, 'ruleForm');
      var urlLang = this.LanguageList.map(function (lang) {
        return lang.label;
      });
      var URL = JSON.parse(this.ruleForm.url);
      urlLang.forEach(function (url) {
        _this2.ruleForm[url] = URL[url] ? URL[url] : '';
      });
      this.dialogTitle = '编辑';
      this.ruleFormVisible = true;
      this.activeName = this.LanguageList[0].label;
      // 在下一个事件循环中清除表单校验状态
      this.$nextTick(function () {
        if (_this2.$refs.ruleForm) {
          _this2.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('是否要删除该问题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _faq.deleteArticle)({
          id: row.id
        }).then(function (response) {
          var dataRes = response.data;
          if (dataRes.errno === 0) {
            _this3.getRuleList();
            _this3.$message.success('删除成功');
          }
        }).catch(function (response) {
          _this3.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    getList: function getList() {
      var _this4 = this;
      (0, _faq.listMenu)().then(function (res) {
        _this4.listLoading = false;
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this4.tabsAll = dataRes.data;
          var tabsOne = [];
          if (dataRes.data.length > 0) {
            dataRes.data.forEach(function (ele) {
              var id = ele.id,
                menuName = ele.menuName;
              tabsOne.push({
                name: id + '',
                label: menuName
              });
            });
            _this4.tabsOne = tabsOne;
            if (_this4.oldTabsOne.length > 0) {
              _this4.activeNameOne = extractUniqueObjectsByProp(tabsOne, _this4.oldTabsOne, 'name')[0].name;
            } else {
              _this4.activeNameOne = tabsOne.filter(function (ele) {
                return ele.name === _this4.activeNameOne;
              }).length > 0 ? _this4.activeNameOne : _this4.tabsOne[0].name;
            }
            _this4.getListTwo(_this4.activeNameOne);
          }
        }
      }).catch(function (err) {
        _this4.listLoading = false;
        console.log(err);
      });
    },
    getListTwo: function () {
      var _getListTwo = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(key) {
        var _this5 = this;
        var target, tabsTwo;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              target = this.tabsAll.filter(function (ele) {
                return ele.id + '' === key;
              });
              if (target.length > 0 && target[0].children && target[0].children.length > 0) {
                tabsTwo = [];
                target[0].children.forEach(function (ele) {
                  var id = ele.id,
                    menuName = ele.menuName;
                  tabsTwo.push({
                    name: id + '',
                    label: menuName
                  });
                });
                this.tabsTwo = tabsTwo;
                if (this.oldTabsTwo.length > 0) {
                  this.activeNameTwo = extractUniqueObjectsByProp(tabsTwo, this.oldTabsTwo, 'name')[0].name;
                } else {
                  this.activeNameTwo = tabsTwo.filter(function (ele) {
                    return ele.name === _this5.activeNameTwo;
                  }).length > 0 ? this.activeNameTwo : this.tabsTwo[0].name;
                }
              } else {
                this.tabsTwo = [];
                this.activeNameTwo = '';
              }
              _context.n = 1;
              return this.getRuleList();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getListTwo(_x) {
        return _getListTwo.apply(this, arguments);
      }
      return getListTwo;
    }(),
    getRuleList: function getRuleList() {
      var _this6 = this;
      var menuId = this.activeNameTwo ? this.activeNameTwo : this.activeNameOne;
      (0, _faq.pageArticle)({
        menuId: menuId,
        page: this.listQuery.page,
        size: this.listQuery.limit
      }).then(function (res) {
        var dataRes = res.data;
        _this6.listLoading = false;
        if (dataRes.errno === 0) {
          console.log(dataRes.data.records, 'target');
          dataRes.data.records.forEach(function (ele) {
            var target = _this6.tabsAll.filter(function (ele) {
              return ele.id + '' === _this6.activeNameOne;
            });
            console.log(target, 'target');
            ele.tabOneId = target[0].id;
            ele.tabOneName = target[0].menuName;
            if (_this6.activeNameTwo) {
              var currentTarget = target[0].children.filter(function (ele) {
                return ele.id + '' === _this6.activeNameTwo;
              });
              ele.tabTwoName = currentTarget[0].menuName;
            } else {
              ele.tabTwoName = '';
            }
          });
          _this6.list = dataRes.data.records;
        }
      });
    },
    // 切换一级类目
    handleClickOne: function handleClickOne(tab, event) {
      this.getListTwo(tab.name);
    },
    // 切换二级类目
    handleClickTwo: function handleClickTwo(tab, event) {
      this.getRuleList();
    },
    // 新增类目
    Add: function Add(type) {
      this.type = type;
      this.dialogStatus = 'create';
      this.dataForm = {
        id: undefined,
        name: '',
        sort: '',
        image: ''
      };
      if (type === 1) {
        // 一级类目
        this.dialogTitle = '新增一级类目';
        this.dialogFormVisible = true;
      } else if (type === 2) {
        // 二级类目
        if (this.activeNameOne && this.tabsOne.length > 0) {
          this.dialogTitle = '新增二级类目';
          this.dialogFormVisible = true;
          this.dataForm.pid = this.activeNameOne;
        } else {
          return this.$message.error('需要新建一级类目');
        }
      }
    },
    // 编辑类目
    Edit: function Edit(type) {
      var _this7 = this;
      this.type = type;
      this.dialogStatus = 'update';
      if (type === 1) {
        // 一级类目
        if (this.activeNameOne && this.tabsOne.length > 0) {
          this.dialogTitle = '编辑一级类目';
          var target = this.tabsAll.filter(function (ele) {
            return ele.id + '' === _this7.activeNameOne;
          });
          this.dataForm.id = target[0].id + '';
          this.dataForm.name = target[0].menuName;
          this.dataForm.sort = target[0].sort;
          this.dataForm.image = target[0].image || '';
          this.dialogFormVisible = true;
        } else {
          return this.$message.error('需要新建一级类目');
        }
      } else if (type === 2) {
        // 二级类目
        if (this.activeNameTwo && this.tabsTwo.length > 0) {
          this.dialogTitle = '编辑二级类目';
          this.dialogFormVisible = true;
          // 指定的一级
          var _target = this.tabsAll.filter(function (ele) {
            return ele.id + '' === _this7.activeNameOne;
          });
          // 指定的二级
          var currentTarget = _target[0].children.filter(function (ele) {
            return ele.id + '' === _this7.activeNameTwo;
          });
          this.dataForm.id = currentTarget[0].id + '';
          this.dataForm.name = currentTarget[0].menuName;
          this.dataForm.sort = currentTarget[0].sort;
        } else {
          return this.$message.error('需要新建二级类目');
        }
      }
    },
    onSaveMenu: function onSaveMenu(type) {
      var _this8 = this;
      if (!this.dataForm.name) return this.$message.error('类目名称不能为空');
      var params = {
        menuName: this.dataForm.name,
        sort: this.dataForm.sort,
        image: this.dataForm.image
      };
      if (this.dataForm.pid) {
        params.pid = this.dataForm.pid;
      }
      // type =1 新增 ; =2 编辑
      if (type === 2 && this.dataForm.id) {
        params.id = this.dataForm.id;
      }
      (0, _faq.saveMenu)(params).then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this8.getList();
          _this8.dialogFormVisible = false;
          _this8.$message.success('操作成功');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 删除类目
    Delete: function Delete(type) {
      var _this9 = this;
      var name = '';
      var id = '';
      if (type === 1) {
        // 一级类目
        name = this.activeNameOne && this.tabsOne.length > 0 ? this.tabsOne.filter(function (ele) {
          return ele.name === _this9.activeNameOne;
        })[0].label : '';
        id = this.activeNameOne;
      } else if (type === 2) {
        // 二级类目
        name = this.activeNameTwo && this.tabsTwo.length > 0 ? this.tabsTwo.filter(function (ele) {
          return ele.name === _this9.activeNameTwo;
        })[0].label : '';
        id = this.activeNameTwo;
      }
      if (!name) return this.$message.error('请选择你要删除的类目');
      this.$confirm('是否确认删除"' + this.multiLanguageDisplay(name) + '"类目，以及"' + this.multiLanguageDisplay(name) + '"类目下的所有内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _faq.deleteMenu)({
          id: id
        }).then(function (res) {
          var dataRes = res.data;
          if (dataRes.errno === 0) {
            // this.oldTabsOne = []
            // this.oldTabsTwo = []
            _this9.getLanguageList();
            _this9.getList();
            _this9.$message.success('删除成功');
          }
        });
      }).catch(function () {});
    },
    // 新增问题
    AddRule: function AddRule() {
      var _this0 = this;
      if (!this.tabsTwo.length) return this.$message.warning('请添加二级菜单');
      this.ruleForm = (0, _objectSpread2.default)({}, this.initRuleForm);
      if (this.activeNameOne && this.tabsOne.length > 0 && this.tabsOne.filter(function (ele) {
        return ele.name === _this0.activeNameOne;
      }).length > 0) {
        this.dialogTitle = '新增';
        this.ruleFormVisible = true;
        this.activeName = this.LanguageList[0].label;
        // 在下一个事件循环中清除表单校验状态
        this.$nextTick(function () {
          if (_this0.$refs.ruleForm) {
            _this0.$refs.ruleForm.clearValidate();
          }
        });
      } else {
        return this.$message.error('需要新建一级类目');
      }
    },
    onSaveArticle: function onSaveArticle(type) {
      var _this1 = this;
      console.log(this.tabsTwo, 'tabsTwo');
      console.log(this.ruleForm);
      if (!this.ruleForm.name) return this.$message.error('标题不能为空');
      var urlLang = this.LanguageList.map(function (lang) {
        return lang.label;
      });
      var URL = {};
      urlLang.forEach(function (url) {
        URL[url] = _this1.ruleForm[url];
      });
      var params = {
        name: this.ruleForm.name,
        url: JSON.stringify(URL),
        status: this.ruleForm.status,
        menuId: this.activeNameTwo ? this.activeNameTwo : this.activeNameOne
      };
      console.log(params, 'params');
      if (type === 2 && this.ruleForm.id) {
        params.id = this.ruleForm.id;
      }
      console.log(params, 'params');
      (0, _faq.saveArticle)(params).then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this1.getRuleList();
          _this1.ruleForm = (0, _objectSpread2.default)({}, _this1.initRuleForm);
          _this1.ruleFormVisible = false;
        }
      });
    },
    onEnable: function onEnable(val, value) {
      var _this10 = this;
      var params = {
        sort: value.sort,
        id: value.id,
        name: value.name,
        url: value.url,
        status: value.status,
        menuId: this.activeNameTwo ? this.activeNameTwo : this.activeNameOne
      };
      (0, _faq.saveArticle)(params).then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this10.getRuleList();
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      if (res.errno === 0) {
        this.dataForm.image = res.data.url;
        this.$message.success('上传成功');
      } else {
        this.$message.error('上传失败');
      }
    }
  }
};